export type JoinFailVariant =
  | 'alreadyJoined'
  | 'notFound'
  | 'notAllowedToAdd'
  | 'userNotAllowed'
  | 'invitationNotFound'
  | 'invitationExpired'
  | 'regionMismatch'
  | 'generic';

/**
 * Maps API join error types (and region mismatch) to modal copy variants.
 */
export function getJoinFailVariant(
  joinTeamErrorType: string | null,
  userCountry?: string | null,
  teamCountry?: string
): JoinFailVariant {
  if (joinTeamErrorType === 'HaveAlreadyJoinedTeamError') {
    return 'alreadyJoined';
  }
  if (joinTeamErrorType === 'TeamNotFoundError') {
    return 'notFound';
  }
  if (joinTeamErrorType === 'TeamNotAllowedToAddMembersError') {
    return 'notAllowedToAdd';
  }
  if (joinTeamErrorType === 'UserNotAllowedError') {
    return 'userNotAllowed';
  }
  if (joinTeamErrorType === 'InvitationNotFoundError') {
    return 'invitationNotFound';
  }
  if (joinTeamErrorType === 'InvitationExpiredError') {
    return 'invitationExpired';
  }
  // Pre-mutation client failures (e.g. missing invite URL context) — generic,
  // not regionMismatch. See useAcceptInvite SESSION_MISSING_INVITE_CONTEXT.
  if (joinTeamErrorType === 'SESSION_MISSING_INVITE_CONTEXT') {
    return 'generic';
  }
  // Only treat as region mismatch when both sides are known; comparing against
  // undefined (team details still loading / never fetched) previously showed a
  // misleading regionMismatch modal on unrelated failures.
  if (userCountry != null && teamCountry != null && userCountry !== teamCountry) {
    return 'regionMismatch';
  }
  return 'generic';
}
